"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7939],{

/***/ 26861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ account_AccountMenu; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@opendoor/auth-fe/dist/auth-fe.esm.js
var auth_fe_esm = __webpack_require__(95674);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/Box.js
var Box = __webpack_require__(46523);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Link/Link.js
var Link = __webpack_require__(22470);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Text/index.js
var Text = __webpack_require__(76614);
// EXTERNAL MODULE: ./node_modules/@opendoor/bricks-next/dist/jsx/components/Box/PressableBox.js
var PressableBox = __webpack_require__(2267);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconHome.mjs
var IconHome = __webpack_require__(55046);
// EXTERNAL MODULE: ./node_modules/@tabler/icons-react/dist/esm/icons/IconLogout2.mjs
var IconLogout2 = __webpack_require__(97501);
// EXTERNAL MODULE: ./src/helpers/i18n.tsx + 5 modules
var helpers_i18n = __webpack_require__(87687);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(77668);
// EXTERNAL MODULE: ./src/components/api/index.ts + 2 modules
var api = __webpack_require__(67945);
;// CONCATENATED MODULE: ./src/helpers/useBuyerOffers.tsx






// Transaction states that indicate an offer is no longer active
var INACTIVE_STATES = [
    "CANCELED",
    "BUYER_WALKED",
    "REJECTED",
    "CONTRACT_FELL_THROUGH",
    "BACKUP_EXPIRED",
    "CLOSED",
    "UNKNOWN", 
];
var useHasActiveBuyerOffers = function() {
    var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var authentication = (0,auth_fe_esm/* useAuth */.aC)().authentication;
    var ref = (0,react.useState)(false), hasActiveOffers = ref[0], setHasActiveOffers = ref[1];
    var ref1 = (0,react.useState)(true), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)(false), hasFetched = ref2[0], setHasFetched = ref2[1];
    var idleCallbackScheduled = (0,react.useRef)(false);
    (0,react.useEffect)(function() {
        // Don't fetch again if we already have the result
        if (hasFetched) {
            return;
        }
        // wait for auth to finish loading before checking offers
        if (!(authentication.state === "authenticated" || authentication.state === "not_authenticated")) {
            return;
        }
        // If not authenticated, user has no active offers
        if (authentication.state === "not_authenticated") {
            setHasActiveOffers(false);
            setIsLoading(false);
            setHasFetched(true);
            return;
        }
        function checkActiveOffers() {
            return _checkActiveOffers.apply(this, arguments);
        }
        function _checkActiveOffers() {
            _checkActiveOffers = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, result, offers, hasActive, e;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                (0,api/* getAthenaClient */.k8)().BuyerOffersMinimal()
                            ];
                        case 1:
                            result = _state.sent();
                            offers = result === null || result === void 0 ? void 0 : (ref = result.customerAccount) === null || ref === void 0 ? void 0 : (ref1 = ref.buying) === null || ref1 === void 0 ? void 0 : ref1.offers;
                            if (!offers || offers.length === 0) {
                                setHasActiveOffers(false);
                                setIsLoading(false);
                                setHasFetched(true);
                                return [
                                    2
                                ];
                            }
                            hasActive = offers.some(function(o) {
                                return !INACTIVE_STATES.includes(o.transactionState);
                            });
                            setHasActiveOffers(hasActive);
                            setIsLoading(false);
                            setHasFetched(true);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            e = _state.sent();
                            esm_exports/* captureException */.Tb(e);
                            setHasActiveOffers(false);
                            setIsLoading(false);
                            setHasFetched(true);
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return _checkActiveOffers.apply(this, arguments);
        }
        // If dropdown is open, fetch immediately
        if (enabled) {
            checkActiveOffers();
            return;
        }
        // Schedule idle callback only once
        if (!idleCallbackScheduled.current && "object" !== "undefined" && "requestIdleCallback" in window) {
            idleCallbackScheduled.current = true;
            var idleCallbackId = window.requestIdleCallback(function() {
                checkActiveOffers();
                idleCallbackId = null; // Clear reference after execution
            });
            return function() {
                // Only cancel if it hasn't executed yet
                if (idleCallbackId !== null) {
                    window.cancelIdleCallback(idleCallbackId);
                }
                idleCallbackScheduled.current = false;
            };
        }
        // If requestIdleCallback is not supported or already scheduled, don't auto-fetch
        // User will fetch on dropdown open instead
        return;
    }, [
        enabled,
        authentication.state,
        hasFetched
    ]);
    return {
        hasActiveOffers: hasActiveOffers,
        isLoading: isLoading
    };
};

// EXTERNAL MODULE: ./src/helpers/useLanguagePreference.ts
var useLanguagePreference = __webpack_require__(44203);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 56 modules
var observability = __webpack_require__(77997);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(35480);
;// CONCATENATED MODULE: ./src/helpers/useLeads.tsx






var buildHubUrl = function(addressUuid) {
    return "".concat(globals/* CONSUMER_FE_URL */.ed, "/dashboard/sell/").concat(addressUuid);
};
var getReadableOfferState = function(offerState) {
    if (offerState === "SENT" || offerState === "ACCEPTED") {
        return "Offered";
    } else if (offerState === "EXPIRED") {
        return "Expired";
    } else if (offerState === "CONTINGENCY_RELEASED" || offerState === "IN_CONTRACT") {
        return "In Contract";
    } else if (offerState === "CLOSED") {
        return "Closed";
    }
    return;
};
var fetchLeads = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(customerUuid) {
        var leadsToShow, ref, ref1, leadsResponse, ref2, ref3, leads;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    leadsToShow = [];
                    if (!customerUuid) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().ListLeadsOnUniqueAddresses({
                            customerUuid: customerUuid
                        })
                    ];
                case 1:
                    leadsResponse = _state.sent();
                    if ((ref = leadsResponse.sellDirect) === null || ref === void 0 ? void 0 : (ref1 = ref.listLeadsOnUniqueAddresses) === null || ref1 === void 0 ? void 0 : ref1.leads) {
                        ;
                        leads = (ref2 = leadsResponse.sellDirect) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.listLeadsOnUniqueAddresses) === null || ref3 === void 0 ? void 0 : ref3.leads;
                        leadsToShow = leads.filter(function(lead) {
                            return lead.isQualified;
                        }).map(function(lead) {
                            var ref, ref1, ref2;
                            return {
                                id: lead.id,
                                url: buildHubUrl((ref = lead.address) === null || ref === void 0 ? void 0 : ref.uuid),
                                address: {
                                    street: (ref1 = lead.address) === null || ref1 === void 0 ? void 0 : ref1.street
                                },
                                readable_offer_state: getReadableOfferState((ref2 = lead.latestOffer) === null || ref2 === void 0 ? void 0 : ref2.state)
                            };
                        });
                    }
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        leadsToShow
                    ];
            }
        });
    });
    return function fetchLeads(customerUuid) {
        return _ref.apply(this, arguments);
    };
}();
var useLeads = function() {
    var ref = (0,auth_fe_esm/* useAuth */.aC)(), user = ref.user, authentication = ref.authentication;
    var ref1 = (0,react.useState)([]), leads = ref1[0], setLeads = ref1[1];
    var customerUuid = user === null || user === void 0 ? void 0 : user.customerUuid;
    (0,react.useEffect)(function() {
        // wait for auth to finish loading before getting leads
        if (!(authentication.state === "authenticated" || authentication.state === "not_authenticated")) {
            return;
        }
        function start() {
            return _start.apply(this, arguments);
        }
        function _start() {
            _start = (0,_async_to_generator/* default */.Z)(function() {
                var leadsToShow;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchLeads(customerUuid)
                            ];
                        case 1:
                            leadsToShow = _state.sent();
                            if (!leadsToShow) {
                                return [
                                    2
                                ];
                            }
                            setLeads(leadsToShow);
                            return [
                                2
                            ];
                    }
                });
            });
            return _start.apply(this, arguments);
        }
        start();
    }, [
        authentication.state,
        customerUuid
    ]);
    return leads;
};

;// CONCATENATED MODULE: ./src/components/account/AccountMenu.tsx













var AccountMenu = function(props) {
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var ref = (0,helpers_i18n/* useT */.NT)(), t = ref.t, i18n = ref.i18n;
    var helpCenterUrl = "https://help.opendoor.com/hc/".concat(i18n.language === "en" ? "en-us" : "es");
    var ref1 = (0,auth_fe_esm/* useAuth */.aC)(), human = ref1.user, logout = ref1.logout;
    var ref2 = (0,react.useState)(false), hasResaleDashboard = ref2[0], setHasResaleDashboard = ref2[1];
    var leads = useLeads();
    var hasActiveOffers = useHasActiveBuyerOffers(props.isExpanded).hasActiveOffers;
    var hasLeads = leads && leads.length > 0;
    (0,react.useEffect)(function() {
        if (!human) {
            return;
        }
        (0,api/* getSessionExtras */.DF)().then(function(extras) {
            setHasResaleDashboard(extras.has_resale_closing_dashboard);
        });
    }, [
        human === null || human === void 0 ? void 0 : human.humanToken,
        human === null || human === void 0 ? void 0 : human.customerUuid
    ]);
    var handleSignOutClick = function() {
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent("cta-click", "account-signout", undefined, {
            categoryOverride: "homepage"
        });
        logout();
    };
    if (!props.isLoggedIn) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PrimaryNavSubmenu, {
            isExpanded: props.isExpanded,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryNavItem, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                        href: helpCenterUrl,
                        children: t("homepage.account_menu.help_center", "Help center")
                    })
                }),
                props.showLanguageToggle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageSwitchItem, {})
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PrimaryNavSubmenu, {
        isExpanded: props.isExpanded,
        children: [
            hasLeads && leads.slice(0, 3).map(function(lead) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryNavItem, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MenuItem, {
                        href: lead.url,
                        children: [
                            lead.address.street,
                            lead.readable_offer_state && " (".concat(lead.readable_offer_state, ")")
                        ]
                    })
                }, lead.id);
            }),
            leads && leads.length > 3 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                    href: "/properties",
                    children: t("homepage.account_menu.more", "More")
                })
            }),
            hasLeads && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {}),
            hasResaleDashboard && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                    href: "/closing-dashboard",
                    children: t("homepage.account_menu.closing_dash", "Closing dash")
                })
            }),
            hasResaleDashboard && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {}),
            hasActiveOffers && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconHome/* default */.Z, {
                        size: 20,
                        stroke: 1.5
                    }),
                    highlighted: true,
                    onClick: function() {
                        return trackEvent("cta-click", "dashboard-link", undefined, {
                            categoryOverride: "homepage"
                        });
                    },
                    href: "/dashboard",
                    children: t("homepage.account_menu.dashboard", "Dashboard")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                    // TODO: remove categoryOverride
                    // observability is initialized with 'cosmos' as the category for all events
                    onClick: function() {
                        return trackEvent("cta-click", "account-link", undefined, {
                            categoryOverride: "homepage"
                        });
                    },
                    href: "/account",
                    children: t("homepage.account_menu.account", "Account")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuItem, {
                    href: helpCenterUrl,
                    children: t("homepage.account_menu.help_center", "Help center")
                })
            }),
            props.showLanguageToggle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageSwitchItem, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryNavItem, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuButton, {
                    onPress: handleSignOutClick,
                    label: t("homepage.account_menu.sign_out", "Sign out"),
                    icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconLogout2/* default */.Z, {
                        size: 20,
                        stroke: 1.5
                    }),
                    analyticsName: "cosmos-account-menu-sign-out"
                })
            })
        ]
    });
};
var PrimaryNavSubmenu = function(param) {
    var isExpanded = param.isExpanded, children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, !isExpanded ? {
        inert: ""
    } : {}), {
        position: "absolute",
        top: 75,
        right: 0,
        backgroundColor: "$backgroundPrimary",
        borderRadius: "$3x",
        borderWidth: 1,
        borderColor: "$borderPrimary",
        minWidth: 198,
        padding: "$2x",
        gap: "$2x",
        overflow: "hidden",
        zIndex: 1000,
        opacity: isExpanded ? 1 : 0,
        "aria-hidden": !isExpanded,
        tag: "ul",
        style: {
            visibility: isExpanded ? "visible" : "hidden",
            transition: "opacity 0.2s ease, visibility 0.2s ease",
            listStyle: "none",
            margin: 0
        },
        children: children
    }));
};
var PrimaryNavItem = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        tag: "li",
        children: children
    });
};
var Divider = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        role: "separator",
        height: 1,
        backgroundColor: "$borderSecondary"
    });
};
var LanguageSwitchItem = function() {
    var ref = (0,useLanguagePreference/* useLanguagePreference */.m)(), defaultToSpanish = ref.defaultToSpanish, toggleLanguage = ref.toggleLanguage;
    var ref1 = (0,react.useState)(false), mounted = ref1[0], setMounted = ref1[1];
    (0,react.useEffect)(function() {
        setMounted(true);
    }, []);
    // SSR has no document.cookie so defaultToSpanish is always false.
    // Defer the cookie-derived label until after hydration to avoid mismatch.
    var label = mounted && defaultToSpanish ? "English" : "Espa\xf1ol";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrimaryNavItem, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MenuButton, {
            onPress: toggleLanguage,
            label: label,
            analyticsName: "cosmos-account-menu-language-switch"
        })
    });
};
var MenuItem = function(param) {
    var href = param.href, children = param.children, icon = param.icon, highlighted = param.highlighted, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
        href: href,
        onPress: onClick,
        analyticsName: "",
        style: {
            textDecoration: "none",
            color: "inherit"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "$4x",
            style: {
                padding: "8px 12px 8px ".concat(icon ? "8px" : "30px")
            },
            borderRadius: highlighted ? "$2x" : "$4x",
            backgroundColor: highlighted ? "$backgroundSecondary" : undefined,
            hoverStyle: {
                backgroundColor: "$backgroundSecondary"
            },
            cursor: "pointer",
            children: [
                icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    width: 20,
                    height: 20,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    style: {
                        color: "var(--contentPrimary)"
                    },
                    children: icon
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$bodyMedium",
                    color: "$contentPrimary",
                    whiteSpace: "nowrap",
                    children: children
                })
            ]
        })
    });
};
var MenuButton = function(param) {
    var onPress = param.onPress, label = param.label, icon = param.icon, analyticsName = param.analyticsName;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
        onPress: onPress,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "$4x",
        style: {
            padding: "8px 12px 8px ".concat(icon ? "8px" : "30px")
        },
        borderRadius: "$4x",
        hoverStyle: {
            backgroundColor: "$backgroundSecondary"
        },
        cursor: "pointer",
        "aria-label": label,
        analyticsName: analyticsName,
        children: [
            icon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                width: 20,
                height: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                style: {
                    color: "var(--contentPrimary)"
                },
                children: icon
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "span",
                typography: "$bodyMedium",
                color: "$contentPrimary",
                whiteSpace: "nowrap",
                children: label
            })
        ]
    });
};
/* harmony default export */ var account_AccountMenu = (AccountMenu);


/***/ }),

/***/ 39922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ LOCALES; }
/* harmony export */ });
var LOCALES = {
    ENGLISH: "en-US",
    SPANISH: "es"
};


/***/ }),

/***/ 87098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ EiChevronDownIcon; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81762);



var EiChevronDownIcon = function() {
    var ChevronDownSVG = function() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("svg", {
            className: "icon",
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "1394.6 97.8 430.2 243.7",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("path", {
                fill: _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_2__/* ["default"].neutrals100 */ .ZP.neutrals100,
                d: "M1824.9 129.7c0 8.4-2.8 15.4-8.4 21L1634.2 333c-11.2 11.2-30.9 11.2-42.1 0l-187.9-182.3c-12.6-11.2-12.6-30.9 0-43.5 11.2-12.6 30.9-12.6 43.5 0l164 162.8L1773 108.7c11.2-11.2 30.9-11.2 43.5 0 5.5 5.6 8.4 14 8.4 21z"
            })
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(ChevronDownSVG, {});
};


/***/ }),

/***/ 54991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ CustomGlobalStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36305);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70917);
/* harmony import */ var _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81762);
/* harmony import */ var _opendoor_bricks_theme_novo_foundations_breakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40156);





var assetPrefix = "/fonts";
// TODO: after bold font is QA'd on /homes, add woff2s and re-order font src for faster loading.
var Graphik = {
    regular: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("@font-face{font-display:swap;font-family:'Graphik';src:url('", assetPrefix, "/graphik-regular/Graphik-Regular.eot?#iefix')\n          format('embedded-opentype'),url('", assetPrefix, "/graphik-regular/Graphik-Regular.woff2') format('woff2'),url('", assetPrefix, "/graphik-regular/Graphik-Regular.woff') format('woff'),url('", assetPrefix, "/graphik-regular/Graphik-Regular.ttf') format('truetype'),url('", assetPrefix, "/graphik-regular/Graphik-Regular.svg#Graphik-Regular') format('svg');font-weight:400;font-style:normal;}"),
    medium: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("@font-face{font-display:swap;font-family:'Graphik';src:url('", assetPrefix, "/graphik-medium/Graphik-Medium.eot?#iefix')\n          format('embedded-opentype'),url('", assetPrefix, "/graphik-medium/Graphik-Medium.woff2') format('woff2'),url('", assetPrefix, "/graphik-medium/Graphik-Medium.woff') format('woff'),url('", assetPrefix, "/graphik-medium/Graphik-Medium.ttf') format('truetype'),url('", assetPrefix, "/graphik-medium/Graphik-Medium.svg#Graphik-Medium') format('svg');font-weight:500;font-style:normal;font-display:swap;}"),
    semibold: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("@font-face{font-display:swap;font-family:'Graphik';src:url('", assetPrefix, "/graphik-semibold/Graphik-Semibold.eot?#iefix')\n          format('embedded-opentype'),url('", assetPrefix, "/graphik-semibold/Graphik-Semibold.woff2') format('woff2'),url('", assetPrefix, "/graphik-semibold/Graphik-Semibold.woff') format('woff'),url('", assetPrefix, "/graphik-semibold/Graphik-Semibold.ttf') format('truetype'),url('", assetPrefix, "/graphik-semibold/Graphik-Semibold.svg#Graphik-Semibold') format('svg');font-weight:600;font-style:normal;font-display:swap;}"),
    bold: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("@font-face{font-display:swap;font-family:'Graphik';src:url('", assetPrefix, "/graphik-bold/Graphik-Bold.woff2') format('woff2'),url('", assetPrefix, "/graphik-bold/Graphik-Bold.woff') format('woff'),url('", assetPrefix, "/graphik-bold/Graphik-Bold.eot?#iefix') format('embedded-opentype'),url('", assetPrefix, "/graphik-bold/Graphik-Bold.ttf') format('truetype'),url('", assetPrefix, "/graphik-bold/Graphik-Bold.svg#Graphik-Bold') format('svg');font-weight:800;font-style:normal;}")
};
var GlobalCss = /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css */ .iv)("*,*:before,*:after{box-sizing:border-box;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}.hp-reskin-address-entry-wrapper .cta-input-wrapper{border-radius:20px;padding:6px;border:1px solid var(--black,#000);}.hp-reskin-v2-address-entry-wrapper .cta-input-wrapper{border-radius:24px;padding:6px 6px 6px 12px;border:1px solid var(--gray-80,#d9d8d7);", _opendoor_bricks_theme_novo_foundations_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .media.smallerThan.MD */ .BC.smallerThan.MD, "{padding:4px 4px 4px 8px;}}.hp-reskin-syw-address-entry-wrapper .cta-input-wrapper{border-radius:24px;border:2px solid var(--gray-80,#d9d8d7);height:64px;min-height:64px;padding:2px 4px 4px 8px;", _opendoor_bricks_theme_novo_foundations_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .media.largerThan.MD */ .BC.largerThan.MD, "{padding:8px 8px 4px 8px;min-height:80px;}&:focus-within{border:2px solid var(--colors-neutrals100);}}.hp-reskin-address-entry-wrapper .cta-button{border-radius:14px;}.hp-reskin-v2-address-entry-wrapper .cta-button{border-radius:18px;padding:19.5px 22px;font-size:var(--fontSizes-16px);}.hp-reskin-syw-address-entry-wrapper .cta-button{border-radius:18px;padding:19.5px 22px;font-size:var(--fontSizes-16px);height:52px;min-height:52px;", _opendoor_bricks_theme_novo_foundations_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .media.largerThan.MD */ .BC.largerThan.MD, "{min-height:60px;font-size:var(--fontSizes-18px);}}.hp-reskin-syw-return-experience-banner-wrapper .cta-button{font-size:var(--fontSizes-16px);", _opendoor_bricks_theme_novo_foundations_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .media.largerThan.MD */ .BC.largerThan.MD, "{font-size:var(--fontSizes-18px);}}.hp-reskin-v2-address-entry-wrapper .cta-input-lite-container input::placeholder{color:var(--gray-40,#706f6e);/* 120 Med */\n    font-family:Graphik;font-size:18px;font-style:normal;font-weight:500;line-height:120%;/* 21.6px */\n    letter-spacing:-0.432px;}.hp-reskin-syw-address-entry-wrapper .cta-input-lite-container input::placeholder{color:var(--gray-40,#706f6e);/* 120 Med */\n    font-family:Graphik;font-size:var(--fontSizes-16px);", _opendoor_bricks_theme_novo_foundations_breakpoints__WEBPACK_IMPORTED_MODULE_1__/* .media.largerThan.MD */ .BC.largerThan.MD, "{font-size:var(--fontSizes-18px);}font-style:normal;font-weight:500;line-height:120%;/* 21.6px */\n    letter-spacing:-0.432px;}body{text-rendering:optimizeLegibility;font:400 16px/1.7 Graphik,sans-serif;color:", _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_2__/* ["default"].neutrals100 */ .ZP.neutrals100, ";margin:0 auto;padding:0;background-color:", _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_2__/* ["default"].neutrals0 */ .ZP.neutrals0, ";}p{margin-top:0;margin-bottom:0;}figure{margin:0;}img{vertical-align:middle;}input,button{font-family:inherit;font-size:inherit;line-height:inherit;}button{background-color:transparent;overflow:visible;}button[data-testid='accordion-button']{border:none;background:none;}a{color:", _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_2__/* ["default"].brand50 */ .ZP.brand50, ";text-decoration:none;}h1,h2,h3,h4,h5,h6,.h1,.h2,.h3,.h4,.h5,.h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit;}h1,.h1,h2,.h2,h3,.h3{margin-top:0px;margin-bottom:10px;}h4,.h4,h5,.h5,h6,.h6{margin-top:10px;margin-bottom:10px;}h1,.h1{font-size:36px;}h2,.h2{font-size:30px;}h3,.h3{font-size:24px;}h4,.h4{font-size:18px;}h5,.h5{font-size:14px;}h6,.h6{font-size:12px;}h1{font:600 46px/1.45 'Graphik',sans-serif;color:#1d2c4c;}h2{font:600 32px/1.45 'Graphik',sans-serif;color:#1d2c4c;}h3{font:600 28px/1.45 'Graphik',sans-serif;color:#1d2c4c;}h4{font:600 24px/1.45 'Graphik',sans-serif;color:#1d2c4c;}h5{font:600 22px/1.45 'Graphik',sans-serif;color:#1d2c4c;}h6{font:600 18px/1.45 'Graphik',sans-serif;color:#1d2c4c;}details summary::-webkit-details-marker,details summary::marker{display:none;content:'';}@media (max-width:767px){h1{font-size:32px;line-height:1.2;}h2{font-size:28px;line-height:1.2;}h3{font-size:24px;line-height:1.2;}h4{font-size:20px;line-height:1.2;}h5{font-size:18px;line-height:1.2;}h6{font-size:16px;line-height:1.2;}}/* aos */\n  [data-aos]{opacity:0;}[data-aos][data-aos][data-aos-duration='50'],body[data-aos-duration='50'] [data-aos]{transition-duration:50ms;}[data-aos][data-aos][data-aos-delay='50'],body[data-aos-delay='50'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='50'].aos-animate,body[data-aos-delay='50'] [data-aos].aos-animate{transition-delay:50ms;}[data-aos][data-aos][data-aos-duration='100'],body[data-aos-duration='100'] [data-aos]{transition-duration:0.1s;}[data-aos][data-aos][data-aos-delay='100'],body[data-aos-delay='100'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='100'].aos-animate,body[data-aos-delay='100'] [data-aos].aos-animate{transition-delay:0.1s;}[data-aos][data-aos][data-aos-duration='150'],body[data-aos-duration='150'] [data-aos]{transition-duration:0.15s;}[data-aos][data-aos][data-aos-delay='150'],body[data-aos-delay='150'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='150'].aos-animate,body[data-aos-delay='150'] [data-aos].aos-animate{transition-delay:0.15s;}[data-aos][data-aos][data-aos-duration='200'],body[data-aos-duration='200'] [data-aos]{transition-duration:0.2s;}[data-aos][data-aos][data-aos-delay='200'],body[data-aos-delay='200'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='200'].aos-animate,body[data-aos-delay='200'] [data-aos].aos-animate{transition-delay:0.2s;}[data-aos][data-aos][data-aos-duration='250'],body[data-aos-duration='250'] [data-aos]{transition-duration:0.25s;}[data-aos][data-aos][data-aos-delay='250'],body[data-aos-delay='250'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='250'].aos-animate,body[data-aos-delay='250'] [data-aos].aos-animate{transition-delay:0.25s;}[data-aos][data-aos][data-aos-duration='300'],body[data-aos-duration='300'] [data-aos]{transition-duration:0.3s;}[data-aos][data-aos][data-aos-delay='300'],body[data-aos-delay='300'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='300'].aos-animate,body[data-aos-delay='300'] [data-aos].aos-animate{transition-delay:0.3s;}[data-aos][data-aos][data-aos-duration='350'],body[data-aos-duration='350'] [data-aos]{transition-duration:0.35s;}[data-aos][data-aos][data-aos-delay='350'],body[data-aos-delay='350'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='350'].aos-animate,body[data-aos-delay='350'] [data-aos].aos-animate{transition-delay:0.35s;}[data-aos][data-aos][data-aos-duration='400'],body[data-aos-duration='400'] [data-aos]{transition-duration:0.4s;}[data-aos][data-aos][data-aos-delay='400'],body[data-aos-delay='400'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='400'].aos-animate,body[data-aos-delay='400'] [data-aos].aos-animate{transition-delay:0.4s;}[data-aos][data-aos][data-aos-duration='450'],body[data-aos-duration='450'] [data-aos]{transition-duration:0.45s;}[data-aos][data-aos][data-aos-delay='450'],body[data-aos-delay='450'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='450'].aos-animate,body[data-aos-delay='450'] [data-aos].aos-animate{transition-delay:0.45s;}[data-aos][data-aos][data-aos-duration='500'],body[data-aos-duration='500'] [data-aos]{transition-duration:0.5s;}[data-aos][data-aos][data-aos-delay='500'],body[data-aos-delay='500'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='500'].aos-animate,body[data-aos-delay='500'] [data-aos].aos-animate{transition-delay:0.5s;}[data-aos][data-aos][data-aos-duration='550'],body[data-aos-duration='550'] [data-aos]{transition-duration:0.55s;}[data-aos][data-aos][data-aos-delay='550'],body[data-aos-delay='550'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='550'].aos-animate,body[data-aos-delay='550'] [data-aos].aos-animate{transition-delay:0.55s;}[data-aos][data-aos][data-aos-duration='600'],body[data-aos-duration='600'] [data-aos]{transition-duration:0.6s;}[data-aos][data-aos][data-aos-delay='600'],body[data-aos-delay='600'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='600'].aos-animate,body[data-aos-delay='600'] [data-aos].aos-animate{transition-delay:0.6s;}[data-aos][data-aos][data-aos-duration='650'],body[data-aos-duration='650'] [data-aos]{transition-duration:0.65s;}[data-aos][data-aos][data-aos-delay='650'],body[data-aos-delay='650'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='650'].aos-animate,body[data-aos-delay='650'] [data-aos].aos-animate{transition-delay:0.65s;}[data-aos][data-aos][data-aos-duration='700'],body[data-aos-duration='700'] [data-aos]{transition-duration:0.7s;}[data-aos][data-aos][data-aos-delay='700'],body[data-aos-delay='700'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='700'].aos-animate,body[data-aos-delay='700'] [data-aos].aos-animate{transition-delay:0.7s;}[data-aos][data-aos][data-aos-duration='750'],body[data-aos-duration='750'] [data-aos]{transition-duration:0.75s;}[data-aos][data-aos][data-aos-delay='750'],body[data-aos-delay='750'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='750'].aos-animate,body[data-aos-delay='750'] [data-aos].aos-animate{transition-delay:0.75s;}[data-aos][data-aos][data-aos-duration='800'],body[data-aos-duration='800'] [data-aos]{transition-duration:0.8s;}[data-aos][data-aos][data-aos-delay='800'],body[data-aos-delay='800'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='800'].aos-animate,body[data-aos-delay='800'] [data-aos].aos-animate{transition-delay:0.8s;}[data-aos][data-aos][data-aos-duration='850'],body[data-aos-duration='850'] [data-aos]{transition-duration:0.85s;}[data-aos][data-aos][data-aos-delay='850'],body[data-aos-delay='850'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='850'].aos-animate,body[data-aos-delay='850'] [data-aos].aos-animate{transition-delay:0.85s;}[data-aos][data-aos][data-aos-duration='900'],body[data-aos-duration='900'] [data-aos]{transition-duration:0.9s;}[data-aos][data-aos][data-aos-delay='900'],body[data-aos-delay='900'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='900'].aos-animate,body[data-aos-delay='900'] [data-aos].aos-animate{transition-delay:0.9s;}[data-aos][data-aos][data-aos-duration='950'],body[data-aos-duration='950'] [data-aos]{transition-duration:0.95s;}[data-aos][data-aos][data-aos-delay='950'],body[data-aos-delay='950'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='950'].aos-animate,body[data-aos-delay='950'] [data-aos].aos-animate{transition-delay:0.95s;}[data-aos][data-aos][data-aos-duration='1000'],body[data-aos-duration='1000'] [data-aos]{transition-duration:1s;}[data-aos][data-aos][data-aos-delay='1000'],body[data-aos-delay='1000'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1000'].aos-animate,body[data-aos-delay='1000'] [data-aos].aos-animate{transition-delay:1s;}[data-aos][data-aos][data-aos-duration='1050'],body[data-aos-duration='1050'] [data-aos]{transition-duration:1.05s;}[data-aos][data-aos][data-aos-delay='1050'],body[data-aos-delay='1050'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1050'].aos-animate,body[data-aos-delay='1050'] [data-aos].aos-animate{transition-delay:1.05s;}[data-aos][data-aos][data-aos-duration='1100'],body[data-aos-duration='1100'] [data-aos]{transition-duration:1.1s;}[data-aos][data-aos][data-aos-delay='1100'],body[data-aos-delay='1100'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1100'].aos-animate,body[data-aos-delay='1100'] [data-aos].aos-animate{transition-delay:1.1s;}[data-aos][data-aos][data-aos-duration='1150'],body[data-aos-duration='1150'] [data-aos]{transition-duration:1.15s;}[data-aos][data-aos][data-aos-delay='1150'],body[data-aos-delay='1150'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1150'].aos-animate,body[data-aos-delay='1150'] [data-aos].aos-animate{transition-delay:1.15s;}[data-aos][data-aos][data-aos-duration='1200'],body[data-aos-duration='1200'] [data-aos]{transition-duration:1.2s;}[data-aos][data-aos][data-aos-delay='1200'],body[data-aos-delay='1200'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1200'].aos-animate,body[data-aos-delay='1200'] [data-aos].aos-animate{transition-delay:1.2s;}[data-aos][data-aos][data-aos-duration='1250'],body[data-aos-duration='1250'] [data-aos]{transition-duration:1.25s;}[data-aos][data-aos][data-aos-delay='1250'],body[data-aos-delay='1250'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1250'].aos-animate,body[data-aos-delay='1250'] [data-aos].aos-animate{transition-delay:1.25s;}[data-aos][data-aos][data-aos-duration='1300'],body[data-aos-duration='1300'] [data-aos]{transition-duration:1.3s;}[data-aos][data-aos][data-aos-delay='1300'],body[data-aos-delay='1300'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1300'].aos-animate,body[data-aos-delay='1300'] [data-aos].aos-animate{transition-delay:1.3s;}[data-aos][data-aos][data-aos-duration='1350'],body[data-aos-duration='1350'] [data-aos]{transition-duration:1.35s;}[data-aos][data-aos][data-aos-delay='1350'],body[data-aos-delay='1350'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1350'].aos-animate,body[data-aos-delay='1350'] [data-aos].aos-animate{transition-delay:1.35s;}[data-aos][data-aos][data-aos-duration='1400'],body[data-aos-duration='1400'] [data-aos]{transition-duration:1.4s;}[data-aos][data-aos][data-aos-delay='1400'],body[data-aos-delay='1400'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1400'].aos-animate,body[data-aos-delay='1400'] [data-aos].aos-animate{transition-delay:1.4s;}[data-aos][data-aos][data-aos-duration='1450'],body[data-aos-duration='1450'] [data-aos]{transition-duration:1.45s;}[data-aos][data-aos][data-aos-delay='1450'],body[data-aos-delay='1450'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1450'].aos-animate,body[data-aos-delay='1450'] [data-aos].aos-animate{transition-delay:1.45s;}[data-aos][data-aos][data-aos-duration='1500'],body[data-aos-duration='1500'] [data-aos]{transition-duration:1.5s;}[data-aos][data-aos][data-aos-delay='1500'],body[data-aos-delay='1500'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1500'].aos-animate,body[data-aos-delay='1500'] [data-aos].aos-animate{transition-delay:1.5s;}[data-aos][data-aos][data-aos-duration='1550'],body[data-aos-duration='1550'] [data-aos]{transition-duration:1.55s;}[data-aos][data-aos][data-aos-delay='1550'],body[data-aos-delay='1550'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1550'].aos-animate,body[data-aos-delay='1550'] [data-aos].aos-animate{transition-delay:1.55s;}[data-aos][data-aos][data-aos-duration='1600'],body[data-aos-duration='1600'] [data-aos]{transition-duration:1.6s;}[data-aos][data-aos][data-aos-delay='1600'],body[data-aos-delay='1600'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1600'].aos-animate,body[data-aos-delay='1600'] [data-aos].aos-animate{transition-delay:1.6s;}[data-aos][data-aos][data-aos-duration='1650'],body[data-aos-duration='1650'] [data-aos]{transition-duration:1.65s;}[data-aos][data-aos][data-aos-delay='1650'],body[data-aos-delay='1650'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1650'].aos-animate,body[data-aos-delay='1650'] [data-aos].aos-animate{transition-delay:1.65s;}[data-aos][data-aos][data-aos-duration='1700'],body[data-aos-duration='1700'] [data-aos]{transition-duration:1.7s;}[data-aos][data-aos][data-aos-delay='1700'],body[data-aos-delay='1700'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1700'].aos-animate,body[data-aos-delay='1700'] [data-aos].aos-animate{transition-delay:1.7s;}[data-aos][data-aos][data-aos-duration='1750'],body[data-aos-duration='1750'] [data-aos]{transition-duration:1.75s;}[data-aos][data-aos][data-aos-delay='1750'],body[data-aos-delay='1750'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1750'].aos-animate,body[data-aos-delay='1750'] [data-aos].aos-animate{transition-delay:1.75s;}[data-aos][data-aos][data-aos-duration='1800'],body[data-aos-duration='1800'] [data-aos]{transition-duration:1.8s;}[data-aos][data-aos][data-aos-delay='1800'],body[data-aos-delay='1800'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1800'].aos-animate,body[data-aos-delay='1800'] [data-aos].aos-animate{transition-delay:1.8s;}[data-aos][data-aos][data-aos-duration='1850'],body[data-aos-duration='1850'] [data-aos]{transition-duration:1.85s;}[data-aos][data-aos][data-aos-delay='1850'],body[data-aos-delay='1850'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1850'].aos-animate,body[data-aos-delay='1850'] [data-aos].aos-animate{transition-delay:1.85s;}[data-aos][data-aos][data-aos-duration='1900'],body[data-aos-duration='1900'] [data-aos]{transition-duration:1.9s;}[data-aos][data-aos][data-aos-delay='1900'],body[data-aos-delay='1900'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1900'].aos-animate,body[data-aos-delay='1900'] [data-aos].aos-animate{transition-delay:1.9s;}[data-aos][data-aos][data-aos-duration='1950'],body[data-aos-duration='1950'] [data-aos]{transition-duration:1.95s;}[data-aos][data-aos][data-aos-delay='1950'],body[data-aos-delay='1950'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='1950'].aos-animate,body[data-aos-delay='1950'] [data-aos].aos-animate{transition-delay:1.95s;}[data-aos][data-aos][data-aos-duration='2000'],body[data-aos-duration='2000'] [data-aos]{transition-duration:2s;}[data-aos][data-aos][data-aos-delay='2000'],body[data-aos-delay='2000'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2000'].aos-animate,body[data-aos-delay='2000'] [data-aos].aos-animate{transition-delay:2s;}[data-aos][data-aos][data-aos-duration='2050'],body[data-aos-duration='2050'] [data-aos]{transition-duration:2.05s;}[data-aos][data-aos][data-aos-delay='2050'],body[data-aos-delay='2050'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2050'].aos-animate,body[data-aos-delay='2050'] [data-aos].aos-animate{transition-delay:2.05s;}[data-aos][data-aos][data-aos-duration='2100'],body[data-aos-duration='2100'] [data-aos]{transition-duration:2.1s;}[data-aos][data-aos][data-aos-delay='2100'],body[data-aos-delay='2100'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2100'].aos-animate,body[data-aos-delay='2100'] [data-aos].aos-animate{transition-delay:2.1s;}[data-aos][data-aos][data-aos-duration='2150'],body[data-aos-duration='2150'] [data-aos]{transition-duration:2.15s;}[data-aos][data-aos][data-aos-delay='2150'],body[data-aos-delay='2150'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2150'].aos-animate,body[data-aos-delay='2150'] [data-aos].aos-animate{transition-delay:2.15s;}[data-aos][data-aos][data-aos-duration='2200'],body[data-aos-duration='2200'] [data-aos]{transition-duration:2.2s;}[data-aos][data-aos][data-aos-delay='2200'],body[data-aos-delay='2200'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2200'].aos-animate,body[data-aos-delay='2200'] [data-aos].aos-animate{transition-delay:2.2s;}[data-aos][data-aos][data-aos-duration='2250'],body[data-aos-duration='2250'] [data-aos]{transition-duration:2.25s;}[data-aos][data-aos][data-aos-delay='2250'],body[data-aos-delay='2250'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2250'].aos-animate,body[data-aos-delay='2250'] [data-aos].aos-animate{transition-delay:2.25s;}[data-aos][data-aos][data-aos-duration='2300'],body[data-aos-duration='2300'] [data-aos]{transition-duration:2.3s;}[data-aos][data-aos][data-aos-delay='2300'],body[data-aos-delay='2300'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2300'].aos-animate,body[data-aos-delay='2300'] [data-aos].aos-animate{transition-delay:2.3s;}[data-aos][data-aos][data-aos-duration='2350'],body[data-aos-duration='2350'] [data-aos]{transition-duration:2.35s;}[data-aos][data-aos][data-aos-delay='2350'],body[data-aos-delay='2350'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2350'].aos-animate,body[data-aos-delay='2350'] [data-aos].aos-animate{transition-delay:2.35s;}[data-aos][data-aos][data-aos-duration='2400'],body[data-aos-duration='2400'] [data-aos]{transition-duration:2.4s;}[data-aos][data-aos][data-aos-delay='2400'],body[data-aos-delay='2400'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2400'].aos-animate,body[data-aos-delay='2400'] [data-aos].aos-animate{transition-delay:2.4s;}[data-aos][data-aos][data-aos-duration='2450'],body[data-aos-duration='2450'] [data-aos]{transition-duration:2.45s;}[data-aos][data-aos][data-aos-delay='2450'],body[data-aos-delay='2450'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2450'].aos-animate,body[data-aos-delay='2450'] [data-aos].aos-animate{transition-delay:2.45s;}[data-aos][data-aos][data-aos-duration='2500'],body[data-aos-duration='2500'] [data-aos]{transition-duration:2.5s;}[data-aos][data-aos][data-aos-delay='2500'],body[data-aos-delay='2500'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2500'].aos-animate,body[data-aos-delay='2500'] [data-aos].aos-animate{transition-delay:2.5s;}[data-aos][data-aos][data-aos-duration='2550'],body[data-aos-duration='2550'] [data-aos]{transition-duration:2.55s;}[data-aos][data-aos][data-aos-delay='2550'],body[data-aos-delay='2550'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2550'].aos-animate,body[data-aos-delay='2550'] [data-aos].aos-animate{transition-delay:2.55s;}[data-aos][data-aos][data-aos-duration='2600'],body[data-aos-duration='2600'] [data-aos]{transition-duration:2.6s;}[data-aos][data-aos][data-aos-delay='2600'],body[data-aos-delay='2600'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2600'].aos-animate,body[data-aos-delay='2600'] [data-aos].aos-animate{transition-delay:2.6s;}[data-aos][data-aos][data-aos-duration='2650'],body[data-aos-duration='2650'] [data-aos]{transition-duration:2.65s;}[data-aos][data-aos][data-aos-delay='2650'],body[data-aos-delay='2650'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2650'].aos-animate,body[data-aos-delay='2650'] [data-aos].aos-animate{transition-delay:2.65s;}[data-aos][data-aos][data-aos-duration='2700'],body[data-aos-duration='2700'] [data-aos]{transition-duration:2.7s;}[data-aos][data-aos][data-aos-delay='2700'],body[data-aos-delay='2700'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2700'].aos-animate,body[data-aos-delay='2700'] [data-aos].aos-animate{transition-delay:2.7s;}[data-aos][data-aos][data-aos-duration='2750'],body[data-aos-duration='2750'] [data-aos]{transition-duration:2.75s;}[data-aos][data-aos][data-aos-delay='2750'],body[data-aos-delay='2750'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2750'].aos-animate,body[data-aos-delay='2750'] [data-aos].aos-animate{transition-delay:2.75s;}[data-aos][data-aos][data-aos-duration='2800'],body[data-aos-duration='2800'] [data-aos]{transition-duration:2.8s;}[data-aos][data-aos][data-aos-delay='2800'],body[data-aos-delay='2800'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2800'].aos-animate,body[data-aos-delay='2800'] [data-aos].aos-animate{transition-delay:2.8s;}[data-aos][data-aos][data-aos-duration='2850'],body[data-aos-duration='2850'] [data-aos]{transition-duration:2.85s;}[data-aos][data-aos][data-aos-delay='2850'],body[data-aos-delay='2850'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2850'].aos-animate,body[data-aos-delay='2850'] [data-aos].aos-animate{transition-delay:2.85s;}[data-aos][data-aos][data-aos-duration='2900'],body[data-aos-duration='2900'] [data-aos]{transition-duration:2.9s;}[data-aos][data-aos][data-aos-delay='2900'],body[data-aos-delay='2900'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2900'].aos-animate,body[data-aos-delay='2900'] [data-aos].aos-animate{transition-delay:2.9s;}[data-aos][data-aos][data-aos-duration='2950'],body[data-aos-duration='2950'] [data-aos]{transition-duration:2.95s;}[data-aos][data-aos][data-aos-delay='2950'],body[data-aos-delay='2950'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='2950'].aos-animate,body[data-aos-delay='2950'] [data-aos].aos-animate{transition-delay:2.95s;}[data-aos][data-aos][data-aos-duration='3000'],body[data-aos-duration='3000'] [data-aos]{transition-duration:3s;}[data-aos][data-aos][data-aos-delay='3000'],body[data-aos-delay='3000'] [data-aos]{transition-delay:0;}[data-aos][data-aos][data-aos-delay='3000'].aos-animate,body[data-aos-delay='3000'] [data-aos].aos-animate{transition-delay:3s;}[data-aos][data-aos][data-aos-easing='linear'],body[data-aos-easing='linear'] [data-aos]{transition-timing-function:cubic-bezier(0.25,0.25,0.75,0.75);}[data-aos][data-aos][data-aos-easing='ease'],body[data-aos-easing='ease'] [data-aos]{transition-timing-function:ease;}[data-aos][data-aos][data-aos-easing='ease-in'],body[data-aos-easing='ease-in'] [data-aos]{transition-timing-function:ease-in;}[data-aos][data-aos][data-aos-easing='ease-out'],body[data-aos-easing='ease-out'] [data-aos]{transition-timing-function:ease-out;}[data-aos][data-aos][data-aos-easing='ease-in-out'],body[data-aos-easing='ease-in-out'] [data-aos]{transition-timing-function:ease-in-out;}[data-aos][data-aos][data-aos-easing='ease-in-back'],body[data-aos-easing='ease-in-back'] [data-aos]{transition-timing-function:cubic-bezier(0.6,-0.28,0.735,0.045);}[data-aos][data-aos][data-aos-easing='ease-out-back'],body[data-aos-easing='ease-out-back'] [data-aos]{transition-timing-function:cubic-bezier(0.175,0.885,0.32,1.275);}[data-aos][data-aos][data-aos-easing='ease-in-out-back'],body[data-aos-easing='ease-in-out-back'] [data-aos]{transition-timing-function:cubic-bezier(0.68,-0.55,0.265,1.55);}[data-aos][data-aos][data-aos-easing='ease-in-sine'],body[data-aos-easing='ease-in-sine'] [data-aos]{transition-timing-function:cubic-bezier(0.47,0,0.745,0.715);}[data-aos][data-aos][data-aos-easing='ease-out-sine'],body[data-aos-easing='ease-out-sine'] [data-aos]{transition-timing-function:cubic-bezier(0.39,0.575,0.565,1);}[data-aos][data-aos][data-aos-easing='ease-in-out-sine'],body[data-aos-easing='ease-in-out-sine'] [data-aos]{transition-timing-function:cubic-bezier(0.445,0.05,0.55,0.95);}[data-aos][data-aos][data-aos-easing='ease-in-quad'],body[data-aos-easing='ease-in-quad'] [data-aos]{transition-timing-function:cubic-bezier(0.55,0.085,0.68,0.53);}[data-aos][data-aos][data-aos-easing='ease-out-quad'],body[data-aos-easing='ease-out-quad'] [data-aos]{transition-timing-function:cubic-bezier(0.25,0.46,0.45,0.94);}[data-aos][data-aos][data-aos-easing='ease-in-out-quad'],body[data-aos-easing='ease-in-out-quad'] [data-aos]{transition-timing-function:cubic-bezier(0.455,0.03,0.515,0.955);}[data-aos][data-aos][data-aos-easing='ease-in-cubic'],body[data-aos-easing='ease-in-cubic'] [data-aos]{transition-timing-function:cubic-bezier(0.55,0.085,0.68,0.53);}[data-aos][data-aos][data-aos-easing='ease-out-cubic'],body[data-aos-easing='ease-out-cubic'] [data-aos]{transition-timing-function:cubic-bezier(0.25,0.46,0.45,0.94);}[data-aos][data-aos][data-aos-easing='ease-in-out-cubic'],body[data-aos-easing='ease-in-out-cubic'] [data-aos]{transition-timing-function:cubic-bezier(0.455,0.03,0.515,0.955);}[data-aos][data-aos][data-aos-easing='ease-in-quart'],body[data-aos-easing='ease-in-quart'] [data-aos]{transition-timing-function:cubic-bezier(0.55,0.085,0.68,0.53);}[data-aos][data-aos][data-aos-easing='ease-out-quart'],body[data-aos-easing='ease-out-quart'] [data-aos]{transition-timing-function:cubic-bezier(0.25,0.46,0.45,0.94);}[data-aos][data-aos][data-aos-easing='ease-in-out-quart'],body[data-aos-easing='ease-in-out-quart'] [data-aos]{transition-timing-function:cubic-bezier(0.455,0.03,0.515,0.955);}[data-aos^='fade'][data-aos^='fade']{opacity:0;transition-property:opacity,transform;}[data-aos^='fade'][data-aos^='fade'].aos-animate{opacity:1;transform:translateZ(0);}[data-aos='fade-up']{transform:translate3d(0,100px,0);}[data-aos='fade-down']{transform:translate3d(0,-100px,0);}[data-aos='fade-right']{transform:translate3d(-100px,0,0);}[data-aos='fade-left']{transform:translate3d(100px,0,0);}[data-aos='fade-up-right']{transform:translate3d(-100px,100px,0);}[data-aos='fade-up-left']{transform:translate3d(100px,100px,0);}[data-aos='fade-down-right']{transform:translate3d(-100px,-100px,0);}[data-aos='fade-down-left']{transform:translate3d(100px,-100px,0);}[data-aos^='zoom'][data-aos^='zoom']{opacity:0;transition-property:opacity,transform;}[data-aos^='zoom'][data-aos^='zoom'].aos-animate{opacity:1;transform:translateZ(0) scale(1);}[data-aos='zoom-in']{transform:scale(0.6);}[data-aos='zoom-in-up']{transform:translate3d(0,100px,0) scale(0.6);}[data-aos='zoom-in-down']{transform:translate3d(0,-100px,0) scale(0.6);}[data-aos='zoom-in-right']{transform:translate3d(-100px,0,0) scale(0.6);}[data-aos='zoom-in-left']{transform:translate3d(100px,0,0) scale(0.6);}[data-aos='zoom-out']{transform:scale(1.2);}[data-aos='zoom-out-up']{transform:translate3d(0,100px,0) scale(1.2);}[data-aos='zoom-out-down']{transform:translate3d(0,-100px,0) scale(1.2);}[data-aos='zoom-out-right']{transform:translate3d(-100px,0,0) scale(1.2);}[data-aos='zoom-out-left']{transform:translate3d(100px,0,0) scale(1.2);}[data-aos^='slide'][data-aos^='slide']{transition-property:transform;}[data-aos^='slide'][data-aos^='slide'].aos-animate{transform:translateZ(0);}[data-aos='slide-up']{transform:translate3d(0,100%,0);}[data-aos='slide-down']{transform:translate3d(0,-100%,0);}[data-aos='slide-right']{transform:translate3d(-100%,0,0);}[data-aos='slide-left']{transform:translate3d(100%,0,0);}[data-aos^='flip'][data-aos^='flip']{backface-visibility:hidden;transition-property:transform;}[data-aos='flip-left']{transform:perspective(2500px) rotateY(-100deg);}[data-aos='flip-left'].aos-animate{transform:perspective(2500px) rotateY(0);}[data-aos='flip-right']{transform:perspective(2500px) rotateY(100deg);}[data-aos='flip-right'].aos-animate{transform:perspective(2500px) rotateY(0);}[data-aos='flip-up']{transform:perspective(2500px) rotateX(-100deg);}[data-aos='flip-up'].aos-animate{transform:perspective(2500px) rotateX(0);}[data-aos='flip-down']{transform:perspective(2500px) rotateX(100deg);}[data-aos='flip-down'].aos-animate{transform:perspective(2500px) rotateX(0);}.lp-section + .lp-section{margin-top:160px;}@media screen and (max-width:1024px){.lp-section + .lp-section{margin-top:80px;}}.has-sheet{overflow:hidden;}// styling for spinning gradient\n  .blur{filter:blur(100px);position:absolute;top:40%;left:50%;transform:translateX(-50%) translateY(-50%);z-index:1;}.gradient-mask{border-radius:99999px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%) scale(1.2);}.spinning-gradient{position:absolute;top:50%;left:50%;width:300px;height:300px;border-radius:50%;transform:translate(-50%,-50%);animation:float 15s linear infinite;box-shadow:0 0 200px 60px rgba(158,127,63,0.4),0 0 120px 60px rgba(157,152,147,0.3),0 0 120px 60px;}@keyframes float{0%{transform:translate(-50%,-50%) rotate(0deg);box-shadow:-157.5px 0 120px 60px rgba(158,127,63,0.4),0 0 120px 60px rgba(157,152,147,0.3),157.5px 0 120px 60px;}25%{transform:translate(-50%,-50%) rotate(90deg);box-shadow:0 0 120px 60px rgba(158,127,63,0.4),-157.5px 0 120px 60px rgba(157,152,147,0.3),157.5px 0 120px 60px;}50%{transform:translate(-50%,-50%) rotate(180deg);box-shadow:157.5px 0 120px 60px rgba(158,127,63,0.4),-157.5px 0 120px 60px rgba(157,152,147,0.3),0 0 120px 60px;}75%{transform:translate(-50%,-50%) rotate(270deg);box-shadow:0 0 120px 60px rgba(158,127,63,0.4),157.5px 0 120px 60px rgba(157,152,147,0.3),-157.5px 0 120px 60px;}100%{transform:translate(-50%,-50%) rotate(360deg);box-shadow:-157.5px 0 120px 60px rgba(158,127,63,0.4),0 0 120px 60px rgba(157,152,147,0.3),157.5px 0 120px 60px;}}// Hide video controls on Safari\n  *::-webkit-media-controls-panel{display:none !important;-webkit-appearance:none;}*::-webkit-media-controls-play-button{display:none !important;-webkit-appearance:none;}*::-webkit-media-controls-start-playback-button{display:none !important;-webkit-appearance:none;}");
var GlobalStyles = function(param) {
    var _fontWeights = param.fontWeights, fontWeights = _fontWeights === void 0 ? [
        "regular",
        "medium",
        "semibold",
        "bold"
    ] : _fontWeights;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .Global */ .xB, {
        styles: [
            _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css.apply */ .iv.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(fontWeights.map(function(weight) {
                return Graphik[weight];
            })).concat([
                GlobalCss
            ]))
        ]
    });
};
var CustomGlobalStyles = function(param) {
    var _fontWeights = param.fontWeights, fontWeights = _fontWeights === void 0 ? [
        "regular",
        "medium",
        "semibold",
        "bold"
    ] : _fontWeights, customCss = param.customCss;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .Global */ .xB, {
        styles: [
            _emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .css.apply */ .iv.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(fontWeights.map(function(weight) {
                return Graphik[weight];
            })).concat([
                customCss
            ]))
        ]
    });
};

/* harmony default export */ __webpack_exports__["Z"] = (GlobalStyles);


/***/ }),

/***/ 37197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KB": function() { return /* binding */ DEFAULT_NAV_MENU_ID; },
/* harmony export */   "Q7": function() { return /* binding */ DEFAULT_NAV_MENU_BUTTON_ID; },
/* harmony export */   "TJ": function() { return /* binding */ MenuOverlay; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37337);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76614);
/* harmony import */ var _opendoor_bricks_complex_Accordion__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(59433);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8013);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4796);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47208);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93298);
/* harmony import */ var _opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26029);
/* harmony import */ var _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99425);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77373);
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35480);









var DEFAULT_NAV_MENU_BUTTON_ID = "nav-menu-button";
var DEFAULT_NAV_MENU_ID = "nav-menu";
var activeStyle = function(props) {
    if (!props.active) return "display: none;";
    return "\n  transform: translateX(0);\n  opacity: 1;\n  visibility: visible;\n  display: inline;\n  ";
};
var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1k8sh3t0"
})("width:320px;padding:20px 45px;background:#ffffff;position:fixed;top:0;left:0;z-index:12;height:100%;overflow-y:scroll;box-shadow:0 0 30px rgba(0,0,0,0.3);visibility:hidden;opacity:0;transform:translateX(-150px);transition:all ease-in-out 0.3s;", activeStyle, ";");
var MenuPanelCategoryA = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e1k8sh3t1"
})("font-size:16px;color:#515778;display:block;padding-bottom:10px;");
var MenuOverlay = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1k8sh3t2"
})("height:100%;width:100%;display:none;opacity:0;background:rgba(255,255,255,0.5);position:fixed;top:0;left:0;z-index:9;transition:all ease-in-out 0.3s;", activeStyle, ";");
var MenuCategory = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            fontWeight: "semibold",
            fontSize: "s2",
            children: props.title
        })
    });
};
var MenuPanelAppDownload = function(props) {
    var href = props.href;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        "aria-label": "Download the Opendoor app",
        analyticsName: "cosmos-download-app-link",
        fontWeight: "semibold",
        padding: "20px 0 20px 50px",
        lineHeight: "s5",
        background: "transparent url('https://images.opendoor.com/source/s3/imgdrop-production/c06e544a05124f56802db784568b6e64.svg?preset=square-2048') left center no-repeat",
        href: href,
        children: props.children
    });
};
var MenuPanelCategoryLink = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryA, {
        href: props.href,
        children: props.children
    });
};
var StandaloneLink = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("a", {
    target: "e1k8sh3t3"
})("display:block;padding:", _opendoor_bricks_theme_eero__WEBPACK_IMPORTED_MODULE_7__/* .space[3] */ .D[3], "px;font-size:16px;font-weight:500;color:#1c2b4d;display:block;cursor:pointer;");
var MenuPanel = function(param) {
    var active = param.active, _navMenuButtonId = param.navMenuButtonId, navMenuButtonId = _navMenuButtonId === void 0 ? DEFAULT_NAV_MENU_BUTTON_ID : _navMenuButtonId, _navMenuId = param.navMenuId, navMenuId = _navMenuId === void 0 ? DEFAULT_NAV_MENU_ID : _navMenuId, toggleMenuOpen = param.toggleMenuOpen;
    var containerRef = react__WEBPACK_IMPORTED_MODULE_0__.useRef(null);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        if (active && containerRef.current) {
            containerRef.current.focus();
        }
    }, [
        active
    ]);
    var trapFocus = function(e) {
        var ref;
        if (e.key !== "Tab") return;
        var containerElements = (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.querySelectorAll('a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
        var firstElement = containerElements && containerElements[0];
        var lastElement = containerElements && containerElements[containerElements.length - 1];
        // tabbing forwards on the last element (Careers)
        if (!e.shiftKey && document.activeElement === lastElement) {
            firstElement.focus();
            return e.preventDefault();
        }
        // tabbing backwards on the first element (Close button)
        if (e.shiftKey && document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(Container, {
        id: navMenuId,
        active: active,
        "aria-labelledby": navMenuButtonId,
        onKeyDown: function(e) {
            return e.key === "Escape" && toggleMenuOpen();
        },
        ref: containerRef,
        tabIndex: -1,
        role: "dialog",
        "aria-modal": "true",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                paddingBottom: "6",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                        tag: "h4",
                        typography: "$subheaderMedium",
                        children: "Menu"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP, {
                        "aria-label": "Close menu",
                        analyticsName: "cosmos-menu-close-button",
                        variant: "icon",
                        onClick: toggleMenuOpen,
                        onKeyDown: trapFocus,
                        size: "sm",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            size: 16
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_complex_Accordion__WEBPACK_IMPORTED_MODULE_12__/* .AccordionList */ .E, {
                variant: "compact",
                analyticsName: "menu-accordion-top",
                listOfAccordions: [
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/",
                                    elementName: "homepage",
                                    children: "Request an offer"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/reviews",
                                    children: "Reviews"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/stories",
                                    children: "Stories"
                                })
                            ]
                        }),
                        panelId: "request-an-offer",
                        startExpanded: true,
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Sell your home"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                href: "/w/homes",
                                children: "Browse homes"
                            })
                        }),
                        panelId: "buy-a-home",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Buy a home"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                href: "/w/builder",
                                children: "Builder trade-up"
                            })
                        }),
                        panelId: "buy-and-sell",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Buy and sell"
                        })
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelAppDownload, {
                href: "https://opendoor.app.link/homepage",
                children: "Download App"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_complex_Accordion__WEBPACK_IMPORTED_MODULE_12__/* .AccordionList */ .E, {
                analyticsName: "menu-accordion-bottom",
                variant: "compact",
                listOfAccordions: [
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/agents#alp-buy--form",
                                    children: "Make an offer"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/agents",
                                    children: "Request an offer"
                                })
                            ]
                        }),
                        panelId: "agents",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Agents"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/vendor-partnerships",
                                    children: "Vendors"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/partner/builder",
                                    children: "Builder"
                                })
                            ]
                        }),
                        panelId: "partners",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Partners"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/about",
                                    children: "Company + Mission"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/faq",
                                    children: "FAQ"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "".concat(_globals__WEBPACK_IMPORTED_MODULE_2__/* .COSMOS_URL */ .EQ, "/articles/topic/press"),
                                    children: "Press"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/contact-us",
                                    children: "Contact"
                                })
                            ]
                        }),
                        panelId: "about",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "About"
                        })
                    },
                    {
                        variant: "secondary",
                        expandOnFocus: true,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            width: "80%",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "".concat(_globals__WEBPACK_IMPORTED_MODULE_2__/* .COSMOS_URL */ .EQ, "/articles/topic/blog"),
                                    children: "Blog"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "".concat(_globals__WEBPACK_IMPORTED_MODULE_2__/* .COSMOS_URL */ .EQ, "/articles/topic/education"),
                                    children: "Education"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/home-sale-calculator",
                                    children: "Home sale calculator"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "/w/mortgage-calculator",
                                    children: "Mortgage calculator"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuPanelCategoryLink, {
                                    href: "".concat(_globals__WEBPACK_IMPORTED_MODULE_2__/* .COSMOS_URL */ .EQ, "/articles/topic/briefs"),
                                    children: "Briefs"
                                })
                            ]
                        }),
                        panelId: "resources",
                        title: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(MenuCategory, {
                            title: "Resources"
                        })
                    }, 
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StandaloneLink, {
                href: "/w/faq",
                children: "FAQ"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StandaloneLink, {
                href: "https://help.opendoor.com",
                children: "Help Center"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StandaloneLink, {
                href: "/jobs",
                onKeyDown: trapFocus,
                children: "Careers"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (MenuPanel);


/***/ }),

/***/ 35374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ determinePreferredLocale; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var _generated_protobuf_journey_data_categories_language_category__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15509);
/* harmony import */ var components_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67945);
/* harmony import */ var components_helpers_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39922);





function determinePreferredLocale(_) {
    return _determinePreferredLocale.apply(this, arguments);
}
function _determinePreferredLocale() {
    _determinePreferredLocale = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var localeFromCookie, anonId, ref, ref1, ref2, ref3, ref4, ref5, result, traitValue;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    localeFromCookie = param.localeFromCookie, anonId = param.anonId;
                    if (localeFromCookie === components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.SPANISH */ .l.SPANISH || localeFromCookie === components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.ENGLISH */ .l.ENGLISH) {
                        return [
                            2,
                            localeFromCookie
                        ];
                    }
                    return [
                        4,
                        (0,components_api__WEBPACK_IMPORTED_MODULE_1__/* .fetchTraitByAnonymousId */ .I6)("language_preference", anonId)
                    ];
                case 1:
                    result = _state.sent();
                    traitValue = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.insightV2) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getTraitForIdentifier) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.trait) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.value) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.kind) === null || ref5 === void 0 ? void 0 : ref5.stringValue;
                    if (traitValue === _generated_protobuf_journey_data_categories_language_category__WEBPACK_IMPORTED_MODULE_0__/* .LanguageCategory_Language.SPANISH */ .hz.SPANISH) return [
                        2,
                        components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.SPANISH */ .l.SPANISH
                    ];
                    if (traitValue === _generated_protobuf_journey_data_categories_language_category__WEBPACK_IMPORTED_MODULE_0__/* .LanguageCategory_Language.ENGLISH */ .hz.ENGLISH) return [
                        2,
                        components_helpers_types__WEBPACK_IMPORTED_MODULE_2__/* .LOCALES.ENGLISH */ .l.ENGLISH
                    ];
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return _determinePreferredLocale.apply(this, arguments);
}


/***/ }),

/***/ 44203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ useLanguagePreference; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36808);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _generated_protobuf_journey_data_categories_language_category__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15509);
/* harmony import */ var components_helpers_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39922);
/* harmony import */ var components_shared_trackers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59431);
/* harmony import */ var _getPreferredLocale__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35374);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87687);
/* harmony import */ var _observability__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77997);










var useLanguagePreference = function() {
    var trackJourneyEvent = (0,_observability__WEBPACK_IMPORTED_MODULE_7__/* .useObservability */ .C3)().trackJourneyEvent;
    var anonId = (0,components_shared_trackers__WEBPACK_IMPORTED_MODULE_4__/* .getAnonymousId */ .y)();
    var localeCookie = js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get("locale");
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(localeCookie === components_helpers_types__WEBPACK_IMPORTED_MODULE_3__/* .LOCALES.SPANISH */ .l.SPANISH), defaultToSpanish = ref[0], setDefaultToSpanish = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!localeCookie), loading = ref1[0], setLoading = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var loadLangPref = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
                var preferredLocale;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0,_getPreferredLocale__WEBPACK_IMPORTED_MODULE_5__/* .determinePreferredLocale */ .B)({
                                    localeFromCookie: localeCookie,
                                    anonId: anonId
                                })
                            ];
                        case 1:
                            preferredLocale = _state.sent();
                            if (preferredLocale === components_helpers_types__WEBPACK_IMPORTED_MODULE_3__/* .LOCALES.SPANISH */ .l.SPANISH) {
                                setDefaultToSpanish(true);
                            }
                            setLoading(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function loadLangPref() {
                return _ref.apply(this, arguments);
            };
        }();
        loadLangPref();
    }, [
        anonId,
        localeCookie
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (localeCookie && _i18n__WEBPACK_IMPORTED_MODULE_6__/* .i18n.language */ .ag.language !== localeCookie) {
            _i18n__WEBPACK_IMPORTED_MODULE_6__/* .i18n.changeLanguage */ .ag.changeLanguage(localeCookie);
        }
    }, [
        localeCookie
    ]);
    // check for pending language toggle event and send it
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (false) {}
        var toggledLanguage = window.localStorage.getItem("toggledLanguage");
        if (toggledLanguage) {
            var languageEvent = parseInt(toggledLanguage, 10);
            trackJourneyEvent("language", "selectEvent", {
                language: languageEvent
            });
            window.localStorage.removeItem("toggledLanguage");
        }
    }, [
        trackJourneyEvent
    ]);
    var toggleLanguage = function() {
        if (false) {}
        var selectedLocale = defaultToSpanish ? components_helpers_types__WEBPACK_IMPORTED_MODULE_3__/* .LOCALES.ENGLISH */ .l.ENGLISH : components_helpers_types__WEBPACK_IMPORTED_MODULE_3__/* .LOCALES.SPANISH */ .l.SPANISH;
        _i18n__WEBPACK_IMPORTED_MODULE_6__/* .i18n.changeLanguage */ .ag.changeLanguage(selectedLocale);
        (0,components_shared_trackers__WEBPACK_IMPORTED_MODULE_4__/* .setCookie */ .d)("locale", selectedLocale, 365);
        var languageEvent = selectedLocale === components_helpers_types__WEBPACK_IMPORTED_MODULE_3__/* .LOCALES.SPANISH */ .l.SPANISH ? _generated_protobuf_journey_data_categories_language_category__WEBPACK_IMPORTED_MODULE_2__/* .LanguageCategory_Language.SPANISH */ .hz.SPANISH : _generated_protobuf_journey_data_categories_language_category__WEBPACK_IMPORTED_MODULE_2__/* .LanguageCategory_Language.ENGLISH */ .hz.ENGLISH;
        // store the language event in localStorage to send after reload
        window.localStorage.setItem("toggledLanguage", languageEvent.toString());
        // reload so we invoke routing to language-specific landing page in Cloudflare
        window.location.reload();
    };
    return {
        defaultToSpanish: defaultToSpanish,
        loading: loading,
        toggleLanguage: toggleLanguage
    };
};


/***/ })

}]);